export const getElementScrollOffset = (element: HTMLElement) => {
  const globalHeaderHeight = 50
  return element.getBoundingClientRect().top - globalHeaderHeight * 3
}

export const scrollWindowTop = () => {
  window.scroll({ top: 0, left: 0 })
}

export const smoothlyScrollToLocation = (top: number) => {
  window.scroll({
    top,
    behavior: 'smooth',
  })
}
